import React from 'react';
import { useState } from 'react';
import { useEffect } from 'react';
import { CountdownCircleTimer } from "react-countdown-circle-timer";

const minuteSeconds = 60;
const hourSeconds = 3600;
const daySeconds = 86400;

const timerProps = {
  isPlaying: true,
  size: 120,
  strokeWidth: 6
};

const getTimeSeconds = (time) => (minuteSeconds - time) | 0;
const getTimeMinutes = (time) => ((time % hourSeconds) / minuteSeconds) | 0;
const getTimeHours = (time) => ((time % daySeconds) / hourSeconds) | 0;

const renderTime = (dimension, time) => {
  return (
    <div className="time-wrapper">
      <div className="time">{time}</div>
      <div>{dimension}</div>
    </div>
  );
};

const CountDown = ({ dateTime }) => {
    const dateFromDB = new Date(dateTime);
    const secondsFromDB = dateFromDB.getTime() / 1000;
    const startTime = Date.now() / 1000; // use UNIX timestamp in seconds
    const endTime = secondsFromDB + 86400; // use UNIX timestamp in seconds

    const remainingTime = endTime - startTime;
    const days = Math.ceil(remainingTime / hourSeconds);
    const dayDuration = days * daySeconds;

    return (
        <>
        <div className='countDownMessage'>
            <h1 className='text-2xl font-semibold mb-4'>Attention</h1>
            <p>Congratulations! Successfully sent your message. As soon as possible I reply to you in 24 hours. If I am unable to reply to your message within 24 hours due to busy schedule or any other reason, I am sincerely sorry for that. If you have an urgent need, you can knock me on Facebook Messenger.</p>
            <h2 className='text-xl font-semibold pt-8 pb-2'>You can't send the message in</h2>
        </div>
        <hr />
        <div className='countDown_container'>
            <CountdownCircleTimer
                {...timerProps}
                colors={[["#ED5506"]]}
                duration={daySeconds}
                initialRemainingTime={remainingTime}
            >
                {({ elapsedTime }) =>
                renderTime("hours", getTimeHours(dayDuration - elapsedTime))
                }
            </CountdownCircleTimer>
            <CountdownCircleTimer
                {...timerProps}
                colors={[["#6D54D0"]]}
                duration={hourSeconds}
                initialRemainingTime={remainingTime % hourSeconds}
                onComplete={(totalElapsedTime) => [
                remainingTime - totalElapsedTime > minuteSeconds
                ]}
            >
                {({ elapsedTime }) =>
                renderTime("minutes", getTimeMinutes(hourSeconds - elapsedTime))
                }
            </CountdownCircleTimer>
            <CountdownCircleTimer
                {...timerProps}
                colors={[["#FF1177"]]}
                duration={minuteSeconds}
                initialRemainingTime={remainingTime % minuteSeconds}
                onComplete={(totalElapsedTime) => [
                remainingTime - totalElapsedTime > 0
                ]}
            >
                {({ elapsedTime }) =>
                renderTime("seconds", getTimeSeconds(elapsedTime))
                }
            </CountdownCircleTimer>

        </div>
        <hr />
        </>
    )
}

export default CountDown;